import { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { useThemeContext } from '@utils/providers/theme-context.tsx';
import { Text } from '@components/atoms/ui-kit/text';

export type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({
  icon,
  title,
  subtitle,
  action,
  className = ''
}: EmptyStateProps) {
  const { getColour } = useThemeContext();

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-12 ${className}`}
    >
      <div
        className="h-16 w-16 rounded-full border-2 border-dashed flex items-center justify-center shrink-0"
        style={{
          borderColor: getColour('hairline'),
          color: getColour('inactiveText')
        }}
      >
        {icon ?? <Inbox className="h-7 w-7" />}
      </div>

      <div className="flex flex-col items-center gap-1 text-center max-w-xs">
        <Text as="p" size="sm" weight="medium">
          {title}
        </Text>
        {subtitle && (
          <Text as="p" size="sm" tone="muted">
            {subtitle}
          </Text>
        )}
      </div>

      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
